class CartProgress extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.giftVariantId;
    this.variantIdTwo = this.dataset.giftTwoVariantId;
    this.thresholdOne = parseFloat(this.dataset.threshold) || 1000000000;
    this.thresholdTwo = parseFloat(this.dataset.thresholdTwo) || 1000000000;
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.addButton = this.querySelector('.single-add-to-cart-button--text');
    if (this.addButton) {
      this.addButton.removeEventListener('click', this._freeGiftAddToCart);
      this.addButton.addEventListener('click', (event) => this._freeGiftAddToCart(event, this.addButton));
    }

    this.addEventListener('change', (event) => {
      const variantSelector = event.target.classList.contains('cart-progress__free-product--variant-select') ?
        event.target :
        event.target.closest('.cart-progress__free-product--variant-select');

      if (variantSelector) {
        this._updateVariant(event, variantSelector);
      }
    });

    this.testThreshold();
  }
  
  async _updateElement() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const section = await res.text();
      const cartDrawer = document.createElement('div');
      cartDrawer.innerHTML = section;

      const updatedMessage = cartDrawer.querySelector('[data-cart-message]');
      const currentMessages = document.querySelectorAll('[data-cart-message]');
      
      if (currentMessages.length && updatedMessage) {
        currentMessages.forEach((message) => {
          message.innerHTML = updatedMessage.innerHTML;
        });
      }

      const updatedBar = cartDrawer.querySelector('[data-bar-progress]');
      const currentBar = document.querySelector('[data-bar-progress]');
      if (currentBar && updatedBar) {
        const progressWidth = updatedBar.getAttribute('style');
        if(progressWidth) {
          currentBar.setAttribute('style', progressWidth)
        }
      }
      
      const updatedProducts = cartDrawer.querySelector('[data-gift-products]');
      const currentProducts = document.querySelector('[data-gift-products]');
      if (currentProducts && updatedProducts) {
        currentProducts.innerHTML = updatedProducts.innerHTML;
      }

      const updatedTimerImage = cartDrawer.querySelector('[data-gift-timer-image]');
      const currentTimerImage = document.querySelector('[data-gift-timer-image]');
      if(updatedTimerImage && currentTimerImage) {
        currentTimerImage.innerHTML = updatedTimerImage.innerHTML;
      }

      const updatedTimer = cartDrawer.querySelector('[data-cart-gift-timer]');
      const currentTimer = document.querySelector('[data-cart-gift-timer]');
      if(updatedTimer && currentTimer) {
        const updatedClasses = updatedTimer.classList;
        console.log(updateClasses)
        currentTimer.setAttribute('class', updatedClasses)
      }
      
      
    } catch (error) {
      console.error(error);
    }
  }

  _updateVariant(event, selector) {
    const parent = event.target.closest('.cart-progress__free-product');
    const id = event.target.value;
    const addToCartButton = parent.querySelector('.cart-progress__free-product--add');
    const images = parent.querySelectorAll('.free-product__image-wrapper img');
    const variantImage = parent.querySelector(`#variant-image--${id}`);

    images.forEach(img => img.style.opacity = 0);
    variantImage.style.opacity = 1;
    addToCartButton.removeAttribute('disabled')
  }

  async _getCart() {
    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data; // Return the parsed JSON cart object
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null; // Return null in case of an error
    }
}
  
  async testThreshold() {
    if(!this.variantId && !this.variantIdTwo) return;
    this.cart = await this._getCart();
    this.cartTotal = this.cart.total_price;
    this.giftInCart = this.cart.items.find((item) => item.variant_id == this.variantId);
    this.giftInCartTwo = this.cart.items.find((item) => item.variant_id == this.variantIdTwo);

    let updates = oakreativ.giftCombineType === 'combine' 
          ? this.setUpdatesCombine() 
          : this.setUpdatesReplace();

    this.autoUpdateCart(updates);
  }

 setUpdatesCombine() {
    let updates = {};
    // Handle gift at first threshold
    if(this.variantId) {
      if (this.cartTotal >= this.thresholdOne) {
        if (!this.giftInCart && oakreativ.giftType == 'automatic') {
          updates[this.variantId] = 1; // Add the gift if not already in the cart
        }
      } else if (this.giftInCart) {
        updates[this.variantId] = 0; // Remove the gift if below the threshold
      }
    }
  
    // Handle gift at second threshold
    if(this.variantIdTwo) {
      if (this.cartTotal >= this.thresholdTwo) {
      if (!this.giftInCartTwo && oakreativ.giftType == 'automatic') {
          updates[this.variantIdTwo] = 1; // Add the second gift if not already in the cart
        }
      } else if (this.giftInCartTwo) {
        updates[this.variantIdTwo] = 0; // Remove the gift if below the threshold
      }
    }

    return updates;
  }
    
  setUpdatesReplace() {
    let updates = {};

    // Handle higher threshold (replace lower gift if applicable)
    if (this.cartTotal >= this.thresholdTwo) {
      if (!this.giftInCartTwo && this.variantIdTwo && oakreativ.giftType == 'automatic') {
        updates[this.variantIdTwo] = 1; // Ensure second gift is in the cart
      }
      if (this.giftInCart && this.variantId) {
        updates[this.variantId] = 0; // Remove the first gift
      }
    } else if (this.cartTotal >= this.thresholdOne && this.cartTotal < this.thresholdTwo) {
      if (!this.giftInCart && this.variantId && oakreativ.giftType == 'automatic') {
          updates[this.variantId] = 1; // Ensure first gift is in the cart
      }
      if (this.giftInCartTwo && this.variantIdTwo) {
          updates[this.variantIdTwo] = 0; // Remove the second gift
      }
    } else {
      // If below both thresholds, remove any gifts
      if (this.giftInCart && this.variantId) {
        updates[this.variantId] = 0;
      }
      if (this.giftInCartTwo && this.variantIdTwo) {
          updates[this.variantIdTwo] = 0;
      }
    }

    return updates;
  }

  autoUpdateCart(updates) {
    if (Object.keys(updates).length === 0) return;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type']; 

    const formData = new FormData();
    for (const [id, qty] of Object.entries(updates)) {
      formData.append(`updates[${id}]`, qty);
    }

    if (this.cartDrawer) {
      formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cartDrawer.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(`${routes.cart_update_url || '/cart/update.js'}`, config)
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
        if (response.status) {
          document.dispatchEvent(
            new CustomEvent('cart:error', {
              detail: {
                source: this.dataset?.source || 'cart-progress',
                errors: response.description,
                message: response.message
              }
            })
          );
          return; 
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state)

            // dispatch cart:change for the entire basket
            document.dispatchEvent(
              new CustomEvent('cart:change', {
                detail: {
                  cart: parsedState,
                  sectionId: this.dataset.source
                }
              })
            );
            // dispatch cart:change for the entire basket

          })
          .catch((error) => {
            console.error('Error fetching cart state:', error);
          });

          this.cartDrawer.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  
  _freeGiftAddToCart(updates) {
  if (Object.keys(updates).length === 0) return;

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type']; 

  const formData = new FormData();
  
  for (const [id, qty] of Object.entries(updates)) {
    formData.append(`updates[${id}]`, qty);
  }

  if (this.cartDrawer) {
    formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    this.cartDrawer.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_update_url || '/cart/update.js'}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        document.dispatchEvent(
          new CustomEvent('cart:error', {
            detail: {
              source: this.dataset?.source || 'free-gift',
              errors: response.description,
              message: response.message
            }
          })
        );
        return; 
      }

      document.dispatchEvent(
        new CustomEvent('cart:change', {
          detail: {
            cart: response,
            sectionId: 'cart-progress' 
          }
        })
      );
    })
    .catch((e) => {
      console.error(e);
    });
}

};
window.customElements.define('cart-progress', CartProgress);
